function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    //Header only
    document.querySelectorAll('[id^="Details-HeaderSubMenu-"] summary').forEach((summary) => {
      if (summary !== event.currentTarget) {
        summary.closest('details').removeAttribute('open');
        summary.setAttribute('aria-expanded', false);
      }
    });

    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const ytIframes = document.querySelectorAll('iframe.js-youtube');

if (ytIframes.length > 0) {
  var tag = document.createElement('script');
  tag.id = 'iframe-demo';
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  function onYouTubeIframeAPIReady() {
    ytIframes.forEach((ytVideo) => {
      playYtIframe(ytVideo)
    })
  }
}

var player;
function playYtIframe(video) {
  player = new YT.Player(video, {
    events: {
      'onReady': (event) => {
        event.target.playVideo();
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll('video[loading="lazy"]'));
  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              if (!videoSource.dataset.src) {
                console.error("No data-src attribute found in video source");
                return false;
              }
              videoSource.src = videoSource.dataset.src;
            }
          }
          video.target.load();
          video.target.removeAttribute('loading');
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });
    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function setCookie(name, value, minutes) {
  const date = new Date();
  date.setTime(date.getTime() + (minutes * 60 * 1000));
  const expires = "expires=" + date.toGMTString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
  name = name + "=";
  let decoded = decodeURIComponent(document.cookie);
  let split = decoded.split(';');
  for (let i = 0; i < split.length; i++) {
    let c = split[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function deleteCookie(name) {
  const date = new Date();
  date.setTime(date.getTime() - 1);
  const expires = "expires=" + date.toGMTString();
  document.cookie = name + "=;" + expires + ";path=/";
}
/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.disclosure__cta):not(.close)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    if (elementToFocus) elementToFocus.setAttribute('aria-expanded', false);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model, modal-opener, details-toggle')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) {
      const modal = document.querySelector(`body > #${this.id}`)
      if (modal && modal.children != this.children) {
        if (modal.hasAttribute('open')) this.setAttribute('open', '');
        modal.replaceWith(this);
      }
      return;
    }
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    if (!this.parentElement || this.parentElement.tagName !== 'BODY') this.connectedCallback();
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', event => {
      event.preventDefault();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class ButtonMedia extends HTMLElement {
  constructor() {
    super();
    let button = this.querySelector('button');
    if (!button) return
    button.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    const media = document.querySelector(`deferred-media[id="${this.dataset.mediaId}"]`);
    if (media) media.loadContent(focus);
  }
}

customElements.define('button-media', ButtonMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.vertical = this.dataset.vertical == 'true' || false;

    if (window.matchMedia('(max-width: 749px)').matches || this.dataset.horizontalOnDesktop) {
      this.vertical = false;
    }

    if (!this.slider || !this.nextButton) return;

    this.offsetPosition = this.vertical ? 'offsetTop' : 'offsetLeft'
    this.scrollPosition = this.vertical ? 'scrollTop' : 'scrollLeft'
    this.clientDimension = this.vertical ? 'clientHeight' : 'clientWidth'

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide, .slider__slide');

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element[this.clientDimension] > 0);
    if (this.sliderItemsToShow.length < 2) return;

    this.vertical = this.dataset.vertical == 'true' || false;
    this.offsetPosition = this.vertical ? 'offsetTop' : 'offsetLeft'
    this.scrollPosition = this.vertical ? 'scrollTop' : 'scrollLeft'
    this.clientDimension = this.vertical ? 'clientHeight' : 'clientWidth'

    if (window.matchMedia('(max-width: 749px)').matches || this.dataset.horizontalOnDesktop) {
      this.vertical = false;
      this.offsetPosition = 'offsetLeft';
      this.scrollPosition = 'scrollLeft';
      this.clientDimension = 'clientWidth';
    }

    this.sliderItemOffset = this.sliderItemsToShow[1][this.offsetPosition] - this.sliderItemsToShow[0][this.offsetPosition];

    this.slidesPerPage = Math.floor((this.slider[this.clientDimension] - this.sliderItemsToShow[0][this.offsetPosition]) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.updateExtraPages();
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  updateExtraPages() {
    this.sliderControlButtons.forEach((button, index) => {
      if (index > this.totalPages -1) {
        button.classList.add('hidden');
      } else {
        button.classList.remove('hidden');
      }
    });
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider[this.scrollPosition] / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        previousPage: previousPage,
        previousElement: this.sliderItemsToShow[previousPage - 1],
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    this.updateSliderLinkButtons();

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider[this.scrollPosition] === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  updateSliderLinkButtons() {
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider[this.clientDimension] + this.slider[this.scrollPosition] - offset;
    return (element[this.offsetPosition] + element[this.clientDimension]) <= lastVisibleSlide && element[this.offsetPosition] >= this.slider[this.scrollPosition];
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider[this.scrollPosition] + (step * this.sliderItemOffset) : this.slider[this.scrollPosition] - (step * this.sliderItemOffset);
    this.slider.scrollTo(this.vertical ? {top: this.slideScrollPosition} : {left: this.slideScrollPosition});
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    if (!this.slider || !this.sliderItemsToShow) return;

    this.enableSliderLooping = true;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide, .slider__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide, .slider__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class ShopTheLook extends SlideshowComponent {
  constructor() {
    super();

    this.addEventListener('slideChanged', this.onSlideChange.bind(this));
  }

  onSlideChange(event) {
    this.updatePreviousSlide(event);
    this.updateSliderHeight(event);
  }
  
  updatePreviousSlide(event) {
    if (event.detail.previousElement) event.detail.previousElement.setAttribute('data-scrolled-to', false);
  }

  updateSliderHeight(event) {
    if (event.detail.currentElement && event.detail.currentElement.getAttribute('data-scrolled-to') === 'true') return;

    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      this.style.setProperty('--padding-bottom', event.detail.currentElement.dataset.paddingBottom + '%');
      this.style.setProperty('--padding-bottom-mobile', event.detail.currentElement.dataset.paddingBottomMobile + '%');

      if (event.detail.currentElement) {
        event.detail.currentElement.querySelectorAll('details-toggle,modal-opener').forEach((cta) => {
          if (cta.classList.contains('hidden')) cta.classList.remove('hidden');
        })
      }
    }, 150);
  }

  onButtonClick(event) {
    event.preventDefault();

    // toggle visibility of ctas inside current shop the look slide
    this.sliderItemsToShow[this.currentPage -1].querySelectorAll('details-toggle,modal-opener').forEach((cta) => {
      if (!cta.classList.contains('hidden')) cta.classList.add('hidden');
    });

    // auto update slideshow height and set it equal to the height of next slide
    let targetPageIndex = event.currentTarget.name === 'next' ? this.currentPage : this.currentPage - 2;

    if (targetPageIndex >= 0 && targetPageIndex < this.sliderItemsToShow.length) {
      this.style.setProperty('--padding-bottom', this.sliderItemsToShow[targetPageIndex].dataset.paddingBottom + '%');
      this.style.setProperty('--padding-bottom-mobile',  this.sliderItemsToShow[targetPageIndex].dataset.paddingBottomMobile + '%');
    }

    super.onButtonClick(event);

    if (targetPageIndex >= 0 && targetPageIndex < this.sliderItemsToShow.length) {
      this.sliderItemsToShow[targetPageIndex].setAttribute('data-scrolled-to', true);

      // toggle visibility of ctas inside target shop the look slide
      this.sliderItemsToShow[targetPageIndex].querySelectorAll('details-toggle,modal-opener').forEach((cta) => {
        if (cta.classList.contains('hidden')) {
          cta.classList.remove('hidden');
        }
      });
    }

    // from last to first slide, and vice versa
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      targetPageIndex = this.sliderItemsToShow.length - 1;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
      targetPageIndex = 0;
    }

    // auto update slideshow height and set it equal to the height of next slide
    this.style.setProperty('--padding-bottom', this.sliderItemsToShow[targetPageIndex].dataset.paddingBottom + '%');
    this.style.setProperty('--padding-bottom-mobile',  this.sliderItemsToShow[targetPageIndex].dataset.paddingBottomMobile + '%');

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });

    this.sliderItemsToShow.forEach((item, index) => {
      if (index !== this.currentPage -1) {
        item.setAttribute('data-scrolled-to', true);
      }
    });

    // toggle visibility of ctas inside target shop the look slide
    this.sliderItemsToShow[targetPageIndex].querySelectorAll('details-toggle,modal-opener').forEach((cta) => {
      if (cta.classList.contains('hidden')) {
        cta.classList.remove('hidden');
      }
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.checkMedia();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventory();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.checkMedia();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const featured_media_id = (this.currentVariant.featured_media.length)? this.currentVariant.featured_media[0].id : this.currentVariant.featured_media.id;
    const elements = mediaGallery.querySelectorAll(`[data-target^="${this.dataset.section}-"], [data-media-id^="${this.dataset.section}-"]`);
    const crossSellItems = mediaGallery.querySelectorAll('[data-cross-sell-item]')

    if (this.currentVariant.featured_media.length) {
      elements.forEach((image) => {
        image.classList.add('hidden');
      })
      for (let i = 0; i < this.currentVariant.featured_media.length; i++) {
        mediaGallery.querySelectorAll(`[data-target="${this.dataset.section}-${this.currentVariant.featured_media[i].id}"], [data-media-id="${this.dataset.section}-${this.currentVariant.featured_media[i].id}"]`).forEach((image) => {
          image.classList.remove('hidden');
        })
      }
    } else {
      elements.forEach((image) => {
        image.classList.remove('hidden');
      })
    }

    if (crossSellItems) crossSellItems.forEach(item => item.classList.remove('hidden'))

    if (!featured_media_id) return;
    mediaGallery.setActiveMedia(`${this.dataset.section}-${featured_media_id}`, true);
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${featured_media_id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const productDrawer = document.querySelector(`#drawer-${this.dataset.originalSection}`);
    if(productDrawer) {
      const drawerForm = productDrawer.querySelector(`#product-drawer-form-${this.dataset.originalSection}`);
      const productId = this.dataset.product;
      const available = drawerForm.querySelector(`div[name="items[${productId}][id]"]`);
      const inputSelect = drawerForm.querySelector(`input[id="items[${productId}]"]`);
      available.dataset.available = this.currentVariant.available;
      inputSelect.value = this.currentVariant.name;
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.getElementById(`pickup-availability-${this.dataset.section}`);
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}${this.dataset.url.includes("?") ? "&" : "?"}variant=${requestedVariantId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination_price = document.getElementById(`price-${this.dataset.section}`);
        const destination_badge = document.getElementById(`badges-${this.dataset.section}`);
        const destination_selling_plans = document.getElementById(`selling-plans-${this.dataset.section}`);
        let itemVariants = html.getElementById(`${sectionId}`);
        if (!itemVariants) {
          itemVariants = html.getElementById(`ProductInfo-${this.dataset.section}`);
        }
        if (!itemVariants) {
          itemVariants = html.getElementById(`MainProduct-${this.dataset.section}`);
        }

        // If the fetched markup has no recognizable product-info wrapper we can't
        // refresh price/badges, but we must still re-enable the add button so the
        // form doesn't get stuck disabled after a variant change.
        if (!itemVariants) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          return;
        }

        const price = itemVariants.querySelector(`.price`);
        const badges = itemVariants.querySelector(`.badges`);
        if (badges) {
          if (!this.currentVariant.available) {
            if (badges.innerHTML.trim() === '') {
              badges.innerHTML = '<span class="badges__item badges__item--sold-out">' + window.variantStrings.soldOut + '</span>';
            }
          } else {
            badges.innerHTML = '';
          }
        }
        const selling_plans = itemVariants.querySelector(`.selling-plans`);
        if (destination_price && price) destination_price.innerHTML = price.outerHTML;
        if (destination_badge && badges) destination_badge.innerHTML = badges.outerHTML;
        if (destination_selling_plans && selling_plans) destination_selling_plans.innerHTML = selling_plans.outerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`) || document.getElementById(`product-drawer-form-${this.dataset.originalSection}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    let isSetAvailable = true;
    const setItems = productForm.querySelectorAll('[data-available]');

    if (setItems.length > 0) {
      setItems.forEach((item) => {
        if (item.getAttribute('data-available') === 'false') {
          isSetAvailable = false;
        }
      });
    }

    if (!disable && !isSetAvailable) {
      disable = true;
      text = window.variantStrings.soldOut;
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  checkMedia() {
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const mediaGalleryThumbnails = document.getElementById(`GalleryThumbnails-${this.dataset.section}`);

    if (!mediaGallery) return;
    if (!mediaGalleryThumbnails) return;

    const thumbnails_shown = mediaGallery.querySelectorAll(`[data-target^="${this.dataset.section}-"]:not(.hidden)`).length;

    if (!thumbnails_shown) {
      const thumbnails = mediaGallery.querySelectorAll(`[data-target^="${this.dataset.section}-"]`);
      const slides = mediaGallery.querySelectorAll(`[data-media-id^="${this.dataset.section}-"]`);
      thumbnails.forEach(thumbnail => thumbnail.classList.remove('hidden'));
      slides.forEach(slide => slide.classList.remove('hidden'));
      if (thumbnails[0]) thumbnails[0].querySelector('button').setAttribute('aria-current', true);
      if (slides[0]) slides[0].classList.add('is-active');
    }

    mediaGalleryThumbnails.resetPages();
  }

  updateInventory() {
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    if (!inventory) return;
    this.inventoryData = JSON.parse(inventory.querySelector('[type="application/json"]').textContent) || {};
    if (this.inventoryData[this.currentVariant.id]) {
      inventory.replaceChild(document.createTextNode(this.inventoryData[this.currentVariant.id]), inventory.firstChild);
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
